import {
  Button,
  // Container,
  // Fab,
  // FormControlLabel,
  // FormLabel,
  // makeStyles,
  // MenuItem,
  // Modal,
  // Radio,
  // RadioGroup,
  Snackbar,
  // TextField,
  // Tooltip,
} from "@material-ui/core";

// import { Add as AddIcon } from "@material-ui/icons";
import React, { useState } from "react";
// import MuiAlert from "@material-ui/lab/Alert";
// import { useDispatch, useSelector } from "react-redux";
import UploadAndDownloadService from "../services/uploadAndDownloadFile";
// import { addNewProduct } from "../reduxSaga/actions";
import SocieteAndUserService from "../services/societeAndUser";
import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
} from "@mui/material";
// import { isNull } from "util";

// const useStyles = makeStyles((theme) => ({
//   fab: {
//     position: "fixed",
//     bottom: 20,
//     right: 20,
//   },
//   container: {
//     borderRadius: 10,
//     boxShadow: "0 3px 5px 2px rgba(18,131,255,0.87)",
//     width: 500,
//     height: 300,
//     backgroundColor: "white",
//     position: "absolute",
//     top: -30,
//     bottom: 0,
//     left: 0,
//     right: 0,
//     margin: "auto",
//     [theme.breakpoints.down("sm")]: {
//       width: "100vw",
//       height: "100vh",
//     },
//   },
//   form: {
//     padding: theme.spacing(2),
//   },
//   item: {
//     marginBottom: theme.spacing(3),
//     marginTop: theme.spacing(3),
//   },

//   cancelAndAddButtom: {
//     marginBottom: theme.spacing(3),
//     marginTop: theme.spacing(5),
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//   },

//   input: {
//     "&::placeholder": {
//       fontStyle: "italic",
//     },
//   },
// }));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const ConfirmAddSociete = ({
  setOnConfirmAddSociete,
  confirmSocieteModel,
  setIsCancel,
}) => {
  // const dispatch = useDispatch();
  // const familyNotification = useSelector(
  //   (state) => state.staff.familyNotification
  // );

  const [open, setOpen] = React.useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const handleClose = () => {
    setOpen(false);
    setOnConfirmAddSociete(false);
    setIsCancel(true);
  };

  const handleConfirm = () => {
    let societe = {
      title: confirmSocieteModel.title,
      matricule: confirmSocieteModel.matricule,
      adresse: confirmSocieteModel.adresse,
      idUserCreation: 0,
      // typeSociete: confirmSocieteModel.typeSociete,
      type: confirmSocieteModel.typeSociete,
      codeTVA: confirmSocieteModel.codeTVA,
      codeCategorie: confirmSocieteModel.codeCategorie,
      numberEtabSecondaire: confirmSocieteModel.numberEtabSecondaire,
      email: confirmSocieteModel.email,
      code: confirmSocieteModel.code,
      numPhone: confirmSocieteModel.numPhone,
      typeTVA: confirmSocieteModel.typeTVA,
      timbre: confirmSocieteModel.timbre,
      tva: confirmSocieteModel.tva,
      typeClient: confirmSocieteModel.typeClient,
      fileUrl: confirmSocieteModel.file,
      isServiceOnly:confirmSocieteModel.isServiceOnly
    };
    console.log("societe", societe);

    if (confirmSocieteModel.file != null) {
      const uploadData = new FormData();
      uploadData.append("picture", confirmSocieteModel.file);

      UploadAndDownloadService.uploadFile(
        "/retail/uploadFile/uploadFile/SocietePicture",
        uploadData
      )
        .then((response) => {
          if (Object.keys(response.data)[0] === "success") {
            societe.fileUrl = response.data.success;
            SocieteAndUserService.addSociete(societe)
              .then((res) => {
                if (Object.keys(res.data)[0] === "societeSuccess") {
                  setOpenAlert(true);

                  //  setOpenS(true);
                  //  setErrorAlertText(
                  //    "Erreur : il ya un probléme de connection"
                  //  );
                }
              })
              .catch(() => {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : il ya un probléme de connection");
              });

            if (openAlert === true) {
              setIsCancel(false);
              setTimeout(setOnConfirmAddSociete(false), 1000);
            }

            //  setMyProductModel(productModel);
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : il ya un erreur  ");
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connection");
        });
    } else {
      //   dispatch(addNewProduct(productModel));

      setOpen(false);
      setOnConfirmAddSociete(false);
    }
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  return (
    <>
      <Dialog
        open={true}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          {"Confirmer vous l'ajout?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div class="card-body">
              <div class="row" style={{ marginTop: -20 }}>
                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">la société est : </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmSocieteModel.typeClient}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Titre: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmSocieteModel.title}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Matricule: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmSocieteModel.matricule}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">
                    Nombre d'établissements secondaires:{" "}
                  </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmSocieteModel.numberEtabSecondaire}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Timbre: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmSocieteModel.timbre}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Email: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmSocieteModel.email}{" "}
                  </label>
                </div>

                {confirmSocieteModel.code && (
                  <div className="form-group" class="col-sm-12">
                    <label htmlFor="inputName">Code: </label>
                    <label
                      htmlFor="inputName"
                      style={{
                        marginLeft: 10,
                        color: "blue",
                        fontFamily: "Garamond",
                      }}
                    >
                      {confirmSocieteModel.code}{" "}
                    </label>
                  </div>
                )}

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Télephone: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmSocieteModel.numPhone}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Adresse: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmSocieteModel.adresse}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Code de catégorie: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmSocieteModel.codeCategorie}{" "}
                  </label>
                </div>

                {confirmSocieteModel.codeCategorie === "C" && (
                  <div className="form-group" class="col-sm-12">
                    <label htmlFor="inputNamejjj">Type de société: </label>
                    <label
                      htmlFor="inputName"
                      style={{
                        marginLeft: 10,
                        color: "blue",
                        fontFamily: "Garamond",
                      }}
                    >
                      {confirmSocieteModel.typeSociete}
                    </label>
                  </div>
                )}

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Code TVA: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmSocieteModel.codeTVA}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Type de TVA : </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmSocieteModel.typeTVA}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">TVA ( % ) : </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmSocieteModel.tva}{" "}
                  </label>
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ marginTop: -20 }}>
          <Button onClick={handleClose} color="primary">
            Annuler
          </Button>
          <Button onClick={handleConfirm} color="primary">
            Confirmer
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={openAlert}
        autoHideDuration={1000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleClose} severity="success">
          Ajout avec success !
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={1000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ConfirmAddSociete;
